import React, { useState } from "react";
import { toast } from "sonner";
import { api } from "../lib/api";
import { useI18n } from "../context/I18nContext";

export default function Ambassador() {
  const { t } = useI18n();
  const [f, setF] = useState({ first_name:"", last_name:"", email:"", phone:"", country:"", social_reach:"", motivation:"" });
  const [loading, setLoading] = useState(false);
  const set = (k, v) => setF(s => ({ ...s, [k]: v }));
  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/ambassador", f);
      toast.success(t("ambassador.thanks"));
      setF({ first_name:"", last_name:"", email:"", phone:"", country:"", social_reach:"", motivation:"" });
    } catch { toast.error(t("common.errGeneric")); }
    finally { setLoading(false); }
  };
  return (
    <div data-testid="ambassador-page">
      <section className="hero-gradient py-24">
        <div className="max-w-5xl mx-auto px-5 lg:px-10">
          <div className="text-xs uppercase tracking-[0.3em] text-warm-orange font-semibold">{t("pages.ambassador.tag")}</div>
          <h1 className="font-display text-deep-blue text-5xl sm:text-6xl lg:text-7xl leading-tight mt-3">{t("pages.ambassador.t1")}<br/><span className="italic text-warm-orange">{t("pages.ambassador.t2")}</span></h1>
          <p className="text-deep-blue/70 mt-6 max-w-2xl">{t("pages.ambassador.sub")}</p>
        </div>
      </section>
      <section className="py-16 bg-ivory">
        <form onSubmit={submit} className="max-w-3xl mx-auto px-5 lg:px-10 grid md:grid-cols-2 gap-4">
          <input required placeholder={t("common.firstName")} className="p-4 rounded-xl border-2 border-black/5 focus:border-gold outline-none" value={f.first_name} onChange={e=>set("first_name",e.target.value)} data-testid="a-first"/>
          <input required placeholder={t("common.lastName")} className="p-4 rounded-xl border-2 border-black/5 focus:border-gold outline-none" value={f.last_name} onChange={e=>set("last_name",e.target.value)} data-testid="a-last"/>
          <input required type="email" placeholder={t("common.email")} className="md:col-span-2 p-4 rounded-xl border-2 border-black/5 focus:border-gold outline-none" value={f.email} onChange={e=>set("email",e.target.value)} data-testid="a-email"/>
          <input placeholder={t("common.phone")} className="p-4 rounded-xl border-2 border-black/5 focus:border-gold outline-none" value={f.phone} onChange={e=>set("phone",e.target.value)} data-testid="a-phone"/>
          <input placeholder={t("common.country")} className="p-4 rounded-xl border-2 border-black/5 focus:border-gold outline-none" value={f.country} onChange={e=>set("country",e.target.value)} data-testid="a-country"/>
          <input placeholder={t("ambassador.socialReach")} className="md:col-span-2 p-4 rounded-xl border-2 border-black/5 focus:border-gold outline-none" value={f.social_reach} onChange={e=>set("social_reach",e.target.value)} data-testid="a-social"/>
          <textarea rows={3} placeholder={t("ambassador.motivation")} className="md:col-span-2 p-4 rounded-xl border-2 border-black/5 focus:border-gold outline-none" value={f.motivation} onChange={e=>set("motivation",e.target.value)} data-testid="a-motiv"/>
          <button disabled={loading} className="btn-gold md:col-span-2 py-4 rounded-full font-semibold" data-testid="a-submit">{loading?t("common.sending"):t("ambassador.submit")}</button>
        </form>
      </section>
    </div>
  );
}
